import { RichText, Switch, Typography } from '@/components/core';
import { RteStoryblok } from '@/types/storyblok/storyblok-types';

import styles from './CookieListItem.module.scss';

type CookieListItemProps = {
    title: string;
    description: RteStoryblok;
    value: boolean;
    onChange?: (value: boolean) => void;
    disabledSwitch?: boolean;
};

export const CookieListItem: React.FC<CookieListItemProps> = ({
    title,
    description,
    value,
    onChange,
    disabledSwitch = false,
}) => (
    <div className={styles.root}>
        <div className={styles.wrapper}>
            <Typography as="h4">{title}</Typography>
            <Switch
                value={value}
                onChange={onChange}
                disabled={disabledSwitch}
            />
        </div>

        <RichText
            looksLike="pSmall"
            classNameRoot={styles.description}
            document={description}
        />
    </div>
);
